module.exports = __webpack_public_path__ + "static/img/T7404_1.c6fb002a.png";